import { atom } from "jotai";

import { RequestRecievedStep } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToRequestReceivedStepAtom = atom(
  null,
  (get, set, { email }: { email: string | null }) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: RequestRecievedStep = {
      step: "RequestRecieved",
      backStep: "ActivateAccount",
      email,
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.RequestRecievedStep", nextStep);
  }
);
